<template>
  <font-awesome-icon
    icon="headset"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHeadset } from '@fortawesome/free-solid-svg-icons'

library.add(faHeadset)

export default {
  name: 'CoozzyHeadsetIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-grey-dark;
  }
</style>
